module.exports = __webpack_public_path__ + "img/hino-logo1.0a37c009.png";